module.exports = __webpack_public_path__ + "img/02.4e3a89a1.jpg";